import i18next from 'i18next';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';
import { setTextVariantStyle } from 'common/utils/variantStyle';
import { getOptionLimitCount, OPTIONS_TYPE } from 'common/utils/config';
import { system900, error } from 'common/components/Mui/styles/color';

/**
 * 剩餘數量文字
 * @param {Object} option - 選項
 * @param {number} option.currentValue - 選項的限制次數
 * @param {number} option.setting.submissionLimit - 選項的限制次數
 * @param {boolean} isEditor - 是否為編輯模式
 * @param {boolean} isError - 是否為錯誤狀態
 * @param {Object} style - 樣式
 * @returns {JSX.Element} 剩餘數量文字
 */
const RemainCountTextField = ({ option = {}, isError = false, isEditor = false, style }) => {
    if (option.deleted) return null;
    if (option.type !== OPTIONS_TYPE.NORMAL) return null;
    const count = getOptionLimitCount(option);

    // 在編輯模式下直接顯示 "-"，避免使用 plural 功能
    if (isEditor) {
        return (
            <Typography variant="overline" css={[remainCountTextStyle(isError), style]}>
                {i18next.t('label.count.remaining').replace('{count, plural, other {#}}', '-')}
            </Typography>
        );
    }

    const previewCount = isError ? 0 : count < 0 ? 0 : count || 0;
    return (
        <Typography variant="overline" css={[remainCountTextStyle(isError), style]}>
            {i18next.t('label.count.remaining', {
                count: previewCount
            })}
        </Typography>
    );
};

export default RemainCountTextField;

const remainCountTextStyle = isError => css`
    padding-top: 2px;
    ${setTextVariantStyle('overline')}
    color: ${isError ? error.color : system900.color};
`;
